(function () {
    'use strict';

    function join() {
        return function (value, joinChar) {

            if (Array.isArray(value)) {
                return value.join(joinChar);
            }

            return value;
        };
    }

    angular.module('ecap.common').filter('join', join);
})();